import React from 'react';
import { Label } from '~/components/atom/Typography';
import type { ExtendedAppConfig } from '~/hooks/useApps';
import CustomMarkdown from '../CustomMarkdown';

const text = {
  discontinued: 'Deze app is beëindigd.',
};

export type Props = {
  app: ExtendedAppConfig;
};

const AppDescription: React.FCC<Props> = ({ app }) => {
  const isDiscontinued = app.catalogStatus === 'discontinued';

  return (
    <>
      {isDiscontinued && (
        <Label margin={[null, null, 'm']}>{text.discontinued}</Label>
      )}
      <CustomMarkdown value={app.description} $dimmed={isDiscontinued} />
    </>
  );
};

export default AppDescription;
